import { render, staticRenderFns } from "./HelpSixthPage.vue?vue&type=template&id=a3b880fc&"
import script from "./HelpSixthPage.vue?vue&type=script&lang=js&"
export * from "./HelpSixthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports